export type LoginData = {
  email: string;
  password: string;
};

export interface OwnProps {
  children: JSX.Element;
}
export enum UserRoles {
  ADMIN,
  USER,
}
export interface User {
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  role: string;
  isAdmin: boolean;
}

export enum Pages {
  Dashboard = "Dashboard",
  Audio = "Audio",
  Video = "Video",
  Conference = "Conference",
  Lights = "Lights",
  Curtains = "Curtains",
  Climate = "Climate",
  Security = "Security",
  Analytics = "Analytics",
  Notifications = "Notifications",
  Logout = "Logout",
}
export interface MenuType {
  id: number;
  name: string;
}

export const TabMenus = [
  "Living Room",
  "CEO’s Office",
  "Conference Room",
  "Lobby",
];
